import React, { useState, useEffect } from "react";
import DataGrid, {
  Column,
  HeaderFilter,
  FilterRow,
  Pager,
  Paging,
  SearchPanel,
  ColumnChooser,
} from "devextreme-react/data-grid";
import LoadPanel from "devextreme-react/load-panel";
import Menu from "devextreme-react/menu";
import "./App-Configuration.scss";
import useFetchConfig from "../../hooks/useFetchConfig";
import { useAuth } from "../../contexts/auth";
import { ConfigEditor, NewApplication, NewConfig } from "../../components";
import Server from "../../api/Server";
import notify from "devextreme/ui/notify";
import { confirm } from "devextreme/ui/dialog";
import { Button } from "devextreme-react";
import { compareAndMergeApplications } from "../../utils";

export const menuData = [
  {
    id: 1,
    value: "PIM",
  },
  { id: 2, value: "userapi" },
  { id: 3, value: "shopz-ecom" },
  { id: 4, value: "webshop-wizard" },
  { id: 4, value: "pos-wizard" },
  { id: 4, value: "erply-to-woo-sync" },
  { id: 4, value: "dashboard" },
  { id: 4, value: "erply-to-wix-sync" },
  { id: 4, value: "ecwid-sync" },
];

const AppConfigurationPage = () => {
  const [selectedConfig, setSelectedConfig] = useState(null);
  const [selected, setSelected] = useState({});
  const [isAdd, setIsAdd] = useState(false);
  const [isNewApp, setIsNewApp] = useState(false);
  const [allApplications, setApplications] = useState([]);

  const { user, accounts, wareHouses, allUsers, registers } = useAuth();

  const { configData, isLoading, fetchConfigData } = useFetchConfig(
    wareHouses,
    registers,
    allUsers
  );

  useEffect(() => {
    setApplications(compareAndMergeApplications(accounts));
  }, [accounts]);

  const handleUpdate = async (value) => {
    const values = {
      application: selected.application,
      level: selected.level,
      name: selected.name,
      type: selected.type,
      value,
    };

    if (selected.level_id) {
      values.level_id = selected.level_id;
    }

    const params = {
      application: selectedConfig,
    };

    try {
      const { data } = await Server.updateAccountConfig(values, user.baseUrl, {
        clientCode: user.clientCode,
        sessionKey: user.sessionKey,
      });

      fetchConfigData(
        params,
        user.baseUrl,
        {
          clientCode: user.clientCode,
          sessionKey: user.sessionKey,
        },
        true
      );

      notify(`${data.message}`, "success", 3000);
    } catch (error) {
      const {
        response: { data },
      } = error;

      if (data) {
        notify(`${data.message}`, "error", 3000);
      } else {
        notify(`Error performing operation`, "error", 3000);
      }
    }
  };

  const onItemClick = (e) => {
    const {
      itemData: { value },
    } = e;
    setSelected({});
    setIsAdd(false);
    setIsNewApp(false);

    if (user) {
      setSelectedConfig(value);
      const params = {
        application: value,
      };
      fetchConfigData(
        params,
        user.baseUrl,
        {
          clientCode: user.clientCode,
          sessionKey: user.sessionKey,
        },
        false
      );
    }
  };

  const itemRender = (itemData) => {
    return (
      <span
        style={
          selectedConfig === itemData.value
            ? { fontSize: "14px", color: "#03a9f4", fontWeight: "bold" }
            : { fontSize: "14px" }
        }
      >
        {itemData.value}
      </span>
    );
  };

  const cellRender = (e) => {
    const { data, key } = e;

    return (
      <div className='action-container'>
        <span
          className='item'
          onClick={() => {
            setSelected(data);
          }}
        >
          Edit
        </span>
        <span className='item' onClick={() => handleDelete(key)}>
          Delete
        </span>
        {/* <span className="item">Copy</span> */}
      </div>
    );
  };

  const onToolbarPreparing = (e) => {
    let toolbarItems = e.toolbarOptions.items;

    toolbarItems.forEach(function (item) {
      item.showText = true;

      if (item.name === "searchPanel" || item.name === "columnChooserButton") {
        item.location = "after";
      } else {
        item.location = "before";
      }
    });

    toolbarItems.unshift({
      widget: "dxButton",
      name: "customAdd",
      options: {
        icon: "plus",
        text: "Add new configuration",
        hint: "Add new configuration",
        onClick: () => setIsAdd(true),
        stylingMode: "text",
      },
      location: "before",
      locateInMenu: "auto",
    });
  };

  const handleDelete = async (id) => {
    const params = {
      application: selectedConfig,
    };
    try {
      const result = await confirm(
        "Are you sure you want to delete this record ?",
        "Confirm Message"
      );

      if (result) {
        const { data } = await Server.deleteAccountConfig(id, user.baseUrl, {
          clientCode: user.clientCode,
          sessionKey: user.sessionKey,
        });

        fetchConfigData(
          params,
          user.baseUrl,
          {
            clientCode: user.clientCode,
            sessionKey: user.sessionKey,
          },
          true
        );

        notify(`${data.message}`, "success", 3000);
      }
    } catch (error) {
      const {
        response: { data },
      } = error;

      if (data) {
        notify(`${data.message}`, "error", 3000);
      } else {
        notify(`Error performing operation`, "error", 3000);
      }
    }
  };

  return (
    <React.Fragment>
      <h2 className={"content-block"}>App Configuration</h2>

      <div className={"content-block config-container"}>
        <Menu
          className='menu'
          dataSource={allApplications}
          // displayExpr={"value"}
          itemRender={itemRender}
          orientation='vertical'
          onItemClick={onItemClick}
        />
        {selectedConfig ? (
          <React.Fragment>
            {isLoading ? (
              <LoadPanel visible={true} />
            ) : (
              <React.Fragment>
                {selected.id && (
                  <ConfigEditor
                    selected={selected}
                    setSelected={setSelected}
                    handleUpdate={handleUpdate}
                  />
                )}

                {isAdd && (
                  <NewConfig
                    setIsAdd={setIsAdd}
                    application={selectedConfig}
                    fetchConfig={fetchConfigData}
                  />
                )}

                {!selected.id && !isLoading && !isAdd ? (
                  <DataGrid
                    dataSource={configData}
                    keyExpr='id'
                    showBorders={true}
                    showRowLines={true}
                    showColumnLines={true}
                    allowColumnReordering={true}
                    allowColumnResizing={true}
                    rowAlternationEnabled={true}
                    hoverStateEnabled={true}
                    wordWrapEnabled={true}
                    onToolbarPreparing={onToolbarPreparing}
                  >
                    <SearchPanel
                      visible={true}
                      width={300}
                      searchVisibleColumnsOnly={true}
                    />
                    <ColumnChooser
                      enabled={true}
                      mode='select'
                      allowSearch={true}
                    />

                    <Paging defaultPageSize={15} />
                    <HeaderFilter allowSearch={true} visible={true} />

                    <FilterRow visible={true} applyFilter='auto' />

                    <Pager
                      showPageSizeSelector={true}
                      allowedPageSizes={[10, 15, 20]}
                      showNavigationButtons={true}
                      showInfo={true}
                    />
                    <Column
                      caption='ID'
                      dataField='id'
                      visible={false}
                      showInColumnChooser={false}
                      sortOrder='desc'
                    />
                    <Column caption='Level' dataField='level' />
                    <Column caption='Level ID' dataField='levelIdName' />
                    <Column caption='Type' dataField='type' />
                    <Column caption='Name' dataField='name' />
                    <Column caption='Value' dataField='value' />
                    <Column
                      cellRender={cellRender}
                      showInColumnChooser={false}
                      alignment='center'
                    />
                  </DataGrid>
                ) : null}
              </React.Fragment>
            )}
          </React.Fragment>
        ) : (
          <div className={"content-block"} style={{ width: "100%" }}>
            <div className={"dx-card responsive-paddings"}>
              <p>
                No application selected. Please select an application to view
                configurations or
              </p>

              <Button
                type='default'
                stylingMode='contained'
                text='Add new configuration'
                onClick={() => {
                  setIsNewApp(true);
                }}
              />
            </div>
          </div>
        )}
        <NewApplication visible={isNewApp} onHide={() => setIsNewApp(false)} />
      </div>
    </React.Fragment>
  );
};

export default AppConfigurationPage;
